import styled from 'styled-components';
import { Title as TitleComponent } from '~components';

export const Container = styled.main`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.km16};
`;

export const Title = styled(TitleComponent)`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m5};
  margin: ${({ theme }) => `${theme.spacing.km6} ${theme.spacing.km0}`};
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
